import axios from 'src/utils/axios';
import getApiUrl from 'src/utils/get-api-url';

/**
 * Service for profile inactivation operations
 */

/**
 * Inactivate a profile/deallocation
 * @param {string} deallocationId - The ID of the deallocation to inactivate
 * @param {Object} data - Inactivation data
 * @param {string} data.reason - The reason for inactivation
 * @param {number} data.inactiveDays - Number of days to inactivate
 * @returns {Promise} API response
 */
export const inactivateProfile = async (deallocationId, data) => {
  try {
    const apiUrl = getApiUrl();
    
    console.log('API URL being used:', apiUrl);
    console.log('Full URL:', `${apiUrl}/deallocation/${deallocationId}/inactivate`);
    console.log('Payload:', {
      reason: data.reason,
      inactiveDays: data.inactiveDays
    });
    
    const response = await axios.post(
      `${apiUrl}/deallocation/${deallocationId}/inactivate`,
      {
        reason: data.reason,
        inactiveDays: data.inactiveDays
      }
    );
    return response;
  } catch (error) {
    console.error('Error inactivating profile:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    throw error;
  }
};

/**
 * Reactivate a profile/deallocation
 * @param {string} deallocationId - The ID of the deallocation to reactivate
 * @returns {Promise} API response
 */
export const reactivateProfile = async (deallocationId) => {
  try {
    const apiUrl = getApiUrl();
    
    console.log('API URL being used:', apiUrl);
    console.log('Full URL:', `${apiUrl}/deallocation/${deallocationId}/activate`);
    
    const response = await axios.put(`${apiUrl}/deallocation/${deallocationId}/activate`);
    return response;
  } catch (error) {
    console.error('Error reactivating profile:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    throw error;
  }
};

/**
 * Get inactivation history for a profile
 * @param {string} deallocationId - The ID of the deallocation
 * @returns {Promise} API response with inactivation history
 */
export const getInactivationHistory = async (deallocationId) => {
  try {
    const apiUrl = getApiUrl();
    const response = await axios.get(`${apiUrl}/deallocation/${deallocationId}/inactivation-history`);
    return response;
  } catch (error) {
    console.error('Error getting inactivation history:', error);
    throw error;
  }
};